// extracted by mini-css-extract-plugin
export default {"HomePage":"HomePage_HomePage__bpf6l","HomePage__heading":"HomePage_HomePage__heading__G84CJ","HomePage__history":"HomePage_HomePage__history__fSnMF"};